import React from "react";
import Container from "@material-ui/core/Container";
import { makeStyles, styled } from "@material-ui/core/styles";
import { Chip, colors, Grid } from "@material-ui/core";
import { Done } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  chip: {
    paddingLeft: "10px",
    paddingRight: "10px",
    marginLeft: "10px",
  },
}));

const ListItem = styled("li")(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

const InvoiceOilFilter = (props) => {
  const { fromQountity,
    setfromQountity,
    selectOilType} = props;
  const classes = useStyles();
  const { t } = useTranslation(["forms"]);

  return (
    <Grid
      style={{
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        listStyle: "none",
        padding: "10px",
        margin: "0px",
      }}
      item
      lg={12} md={12}  sm={12} xs={12}
      spacing={1}
      component="ul"
    >
      {selectOilType.map((x) => {
        return (
          <>
          <Grid item lg={1} md={2} sm={4} xs={4}  spacing={1} >
          <ListItem key={x.id}>
            {x.id === fromQountity.select.id ? (
              <Chip
                className={classes.chip}
                label={t(x.label)}
                icon={<Done />}
                style={{
                  backgroundColor: colors.green[300] ,
                  color: "#fff",
                }}
                clickable
              />
            ) : 
            (
              <Chip
                className={classes.chip}
                label={t(x.label)}
                variant="outlined"
                color={ "green"}
                onClick={() => {
                 setfromQountity({ ...fromQountity, select: x });
                }}
              />
            )}
          </ListItem>
          </Grid>
          </>
        );
      })}
    </Grid>
  );
};

export default InvoiceOilFilter;
